<template>
  <div>
    <portal to="sidebar-menu">

      <div>
        <nav-back-button to="/organizations">
          {{$t('organizations.details.menu.back')}}
        </nav-back-button>
        <div class="row">
          <div class="col-12">
            <organization-card class="mb-4" :organization="organization"/>
            <nav-list :items="navigationItems">
            </nav-list>

            <base-button @click="onMergeClick" block outline>
              {{$t('organizations.details.merge')}}
            </base-button>
          </div>
        </div>
      </div>

    </portal>

    <modal :show.sync="showMergeModal" :title="$t('organizations.details.merge')">
      <fg-input :label="$t('organizations.details.mergeSelect')"
                required>
        <organization-autocomplete v-model="mergeModel.selectedOrganization" :exclude-organizations="[organization]"/>
      </fg-input>
      <fg-input required
                :label="$t('organizations.details.mergeSelect.agree')"
                class="mt-4">
        <base-checkbox v-model="mergeModel.acceptMerge">
          <template v-slot:label>
            <div class="mt-1">
              <strong>{{mergeModel.selectedOrganization.name || '- -'}}</strong>
            {{$t('organizations.details.merge.tip')}}
            <strong>{{organization.name}}. </strong>
            <strong>{{mergeModel.selectedOrganization.name || '- -'}}</strong>
              {{$t('organizations.details.merge.tip2')}}
            </div>
          </template>
        </base-checkbox>
      </fg-input>

      <div class="flex w-full justify-center">
        <submit-button :disabled="!mergeModel.selectedOrganization.id || !mergeModel.acceptMerge"
                       :loading="loadingMerge"
                       @click="mergeOrganization">
        </submit-button>
      </div>
    </modal>
  </div>
</template>
<script>
  import OrganizationAutocomplete from 'src/components/Autocomplete/OrganizationAutocomplete'
  import OrganizationCard from 'src/components/Cards/OrganizationCard'
  import OrganizationService from 'src/services/OrganizationService'

  export default {
    name: 'organization-details-menu',
    components: {
      OrganizationAutocomplete,
      OrganizationCard
    },
    data () {
      return {
        loadingMerge: false,
        showMergeModal: false,
        mergeModel: {
          selectedOrganization: {},
          acceptMerge: false,
        },
        navigationItems: [
          {
            name: this.$t('generic.general'),
            type: 'group'
          },
          {
            routeName: 'organisation_details',
            name: this.$t('organization.details.menu.edit')
          },
          {
            routeName: 'organisation_jobs',
            name: this.$t('organization.details.menu.jobs')
          },
        ]
      }
    },
    computed: {
      organization () {
        return this.$store.state.organization.currentOrganization || {}
      }
    },
    methods: {
      onMergeClick () {
        this.showMergeModal = true
      },
      async mergeOrganization () {
        try {
          this.loadingMerge = true
          await OrganizationService.mergeOrganization(this.$route.params.id, {
            organisation_id: this.mergeModel.selectedOrganization.id
          })
          this.showMergeModal = false
          this.$emit('refresh')
        } finally {
          this.loadingMerge = false
        }
      }
    }
  }
</script>
<style>
</style>
